"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AuthCodeRecordBase = void 0;
/* eslint-disable require-jsdoc */
const constants_1 = require("../../constants");
class AuthCodeRecordBase {
    constructor(uid) {
        this.uid = uid;
        const now = new Date();
        this.expirationDate = new Date(now.getTime() + 5 * 60 * 1000);
    }
    static collectionPath() {
        return constants_1.constants.COLLECTION_PATH_AUTH_CODE_RECORD;
    }
}
exports.AuthCodeRecordBase = AuthCodeRecordBase;
